import type {ReactElement} from 'react';
import {useContext} from 'react';
import {MergeTags} from '@Components/merge-tags/merge-tags';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {getMergeTagsFromOptionId} from '@EmailMakerReact/lib/email-maker-merge-tag-library';
import {updateMergeTags} from '@EmailMakerReact/lib/email-maker-social-signup-library';
import {EMAIL_MAKER_COMPONENT_TYPES} from '@EmailMakerReact/email-maker-react.constants';
import {replaceMergeTag} from '@Libraries/merge-tags-library';
import type {EmailMakerControlProps} from '../../right-panel-registry.types';

export function MergeTagsControl({component}: EmailMakerControlProps): ReactElement {
  const {editor} = useContext(emailMakerContext);

  function handleTagAdded(_ccid: string, value: string): void {
    if (!editor) {
      return;
    }
    const selected = editor.getSelected();
    if (!selected) {
      return;
    }
    selected.append(getMergeTagsFromOptionId(value));
    updateMergeTags(editor, selected);
  }

  function handleTagRemoved(_ccid: string, value: string): void {
    const selectedComponent = editor?.getSelected();
    if (!selectedComponent) {
      return;
    }
    const element = selectedComponent.getEl();
    if (!element) {
      return;
    }
    const newContent = replaceMergeTag(value, element.innerText, '');
    selectedComponent.components(newContent);
  }

  function handleDefaultValueUpdate(_ccid: string, mergeTagKey: string, defaultValue: string): void {
    const wrapper = editor?.getWrapper();
    if (!wrapper) {
      return;
    }
    wrapper.find(`[data-gjs-type="${EMAIL_MAKER_COMPONENT_TYPES.text.PMW_TEXT}"]`).forEach((textComponent) => {
      const element = textComponent.getEl();
      const currText = element ? element.innerText : '';
      const newContent = replaceMergeTag(mergeTagKey, currText, getMergeTagsFromOptionId(mergeTagKey, defaultValue));
      textComponent.components(newContent);
    });
  }

  return <MergeTags ccid={component.ccid} onTagAdded={handleTagAdded} onTagRemoved={handleTagRemoved} onDefaultValueUpdate={handleDefaultValueUpdate} />;
}
